import { useState } from 'react'
import { localestr, processFinishTo } from '../utils.js'
import icon from '../icons.svg';
import { PAY_TYPES } from '../constants.js';

function DeliveryTab({ userId, cmdClick, Orders, CourierOrd, CourierTrn, Rights, Consts, docType, showMap, showMsg, runCmd }) {
  const [open, setOpen] = useState(true)

  const filter_date = new Date()
  filter_date.setHours(filter_date.getHours() + 2)
  const str_date = filter_date.toISOString()


  let ord = []
  if(Orders) ord=Orders.filter(el=>el.docType===docType&&(el.date||str_date)<str_date).sort((a,b)=>{
    if (a.finish_to && b.finish_to && a.finish_to < b.finish_to) return -1
    if (a.finish_to && b.finish_to && a.finish_to > b.finish_to) return 1
    return 0
  })

  const stl1 = { width: '170px', height: '90px', display: 'table', padding: '4px' }
  const stl2 = { display: 'table-cell', verticalAlign: 'middle', whiteSpace: 'pre-wrap' }
  if (window.innerWidth < 400) stl1.width = 'calc(33% - 10px)'
  let content = ord.map((el, idx) => {
    let cap = (el.phone || '') + ' ' + (el.name || '')
    if (cap) cap += "\n"
    if (el.address) cap += el.address + "\n"
    let cls = ''
    let cantClick = false

    let ttl2 = (new Date(el.open || el.date)).toLocaleString()
    if ((new Date()).toLocaleString().substring(0, 10) === ttl2.substring(0, 10)) ttl2 = ttl2.substring(12, 20)
    else ttl2 = ttl2.substring(0, 17)
    if (el.author.id === userId) {
      cap += el.sum.toFixed(2) + '   ' + ttl2
      cls = 'order'
      if (el.online) cls = 'order2'
    } else {
      if (!Rights.urAdmin && !Rights.urOrder) cantClick = true
      else cap += el.sum.toFixed(2) + '   ' + ttl2 + "\n"
      cap += el.author ? el.author.name : ''
      cls = 'select'
    }
    let ico = null
    if (el.kitch_status) ico = <div style={{ display: 'inline-block', width: '24px', height: '24px', margin: '-2px 0px -5px 3px', backgroundColor: 'var(--tbl1-tx-color)', mask: 'url(' + icon + '#btn4)' }}></div>
    if (el.status > 1) ico = <div style={{ display: 'inline-block', width: '24px', height: '24px', margin: '-2px 0px -5px 3px', backgroundColor: 'var(--tbl1-tx-color)', mask: 'url(' + icon + '#btn24)' }}></div>
    let cap2 = ''
    let cap3 = ''
    if (el.courier_name) cap2 = "\n" + el.courier_name
    if (el.reward) cap2 += ' (' + el.reward + ')'
    if (el.finish_to) {
      const hashIndex = el.finish_to.indexOf('#')
      if (hashIndex !== -1) {
        cap2 += "\n" + localestr('через') + ' '
        cap3 = processFinishTo(el.finish_to.substring(0, hashIndex))
      } else {
        cap2 += "\n" + localestr('на') + ' ' + el.finish_to + ' '
        cap3 = processFinishTo(el.finish_to)
      }
    }
    if (cantClick) return (<div key={idx} style={stl1}><div className={'button ' + cls} style={stl2}>{cap}{cap2}{cap3}</div></div>)
    else return (<div key={idx} style={stl1}><div className={'button ' + cls} style={stl2} onClick={() => { cmdClick(el) }}>{cap}{ico}{cap2}{cap3}</div></div>)
  })

  if (Consts?.constXprs) {
    const showDelivered = (courier) => {
      let data = localestr("Пусто");
      if (courier?.delivered.length > 0) {
        //const cashOrders = courier.delivered.filter(o => o.payType === "0");
        //const cardOrders = courier.delivered.filter(o => o.payType === "1");
        const sortOrders = courier.delivered.sort((a, b) => {
          if (a.date && b.date && a.date < b.date) return -1
          if (a.date && b.date && a.date > b.date) return 1
          return 0
        });
        const renderOrders = (orders) => {
          if (orders && orders.length) return (
            <div>
              {orders.map(order => (
                <div key={order.id} style={{ border: '1px dotted #0003', padding: '0 5px 5px', marginBottom: '5px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <b>№{order.id}&nbsp;</b>{order.address}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    {order.status === '3' ?
                      <span style={{ color: '#080' }}>{PAY_TYPES[order.payType] + ' ' + localestr('в закладі')}</span>
                      :
                      <span>{PAY_TYPES[order.payType]}</span>
                    }
                    {order.status === '3' ?
                      <span style={{ color: '#080' }}><b>{order.amount}</b></span>
                      :
                      <b>{order.amount}</b>
                    }
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 'small', fontStyle: 'italic' }}>
                    <span>&nbsp;&nbsp;{localestr('винагорода')}</span>
                    <span>{order.reward}</span>
                  </div>
                </div>
              ))}
            </div>
          )
        }
        data = (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {/*renderOrders(cashOrders, localestr("Готівка"))*/}
            {/*renderOrders(cardOrders, localestr("Картка"))*/}
            {renderOrders(sortOrders)}
            <div style={{ border: '1px dashed #0008', marginTop: '5px', padding: '2px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 3px' }}>
                <span>{localestr("Разом картка:")}</span>
                <b>{parseFloat(courier.deliveredTotal1).toFixed(2)}</b>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 3px' }}>
                <span>{localestr("Разом готівка:")}</span>
                <b>{parseFloat(courier.deliveredTotal0).toFixed(2)}</b>
              </div>
              {courier.transactionsTotal ?
                <>
                  <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 3px' }}>
                    <span>{localestr("Видача готівки:")}</span>
                    <b style={{ color: '#c00' }}>-{parseFloat(courier.transactionsTotal).toFixed(2)}</b>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 3px' }}>
                    <span>{localestr("Залишок готівки:")}</span>
                    <b>{(parseFloat(courier.deliveredTotal0) - parseFloat(courier.transactionsTotal)).toFixed(2)}</b>
                  </div>
                </>
                :
                null
              }
              <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 3px' }}>
                <span>{localestr("Разом винагорода:")}</span>
                <b>{parseFloat(courier.deliveredReward).toFixed(2)}</b>
              </div>
            </div>
          </div>
        );
      }
      //console.log(courier)
      showMsg(data, localestr('Виконані замовлення ') + courier.name);
    };
    const showTaken = (courier) => {
      let data = localestr("Пусто");
      if (courier?.taken.length > 0) {
        data = <div style={{ display: 'flex', flexDirection: 'column' }}>{
          courier.taken.map((order) => (<div key={order.id} style={{ border: '1px dotted #0003', padding: '0 5px 5px', marginBottom: '5px' }}>
            <div><b>№{order.id}&nbsp;</b>{order.address}</div>
            {order.status === '3' ?
              <div><span style={{ color: '#080' }}><b>{localestr('Оплачено: ')}&nbsp;</b>{order.amount}</span><b>&nbsp;&nbsp;&nbsp;{localestr('винагорода: ')}&nbsp;</b>{order.reward}</div>
              :
              <div><b>{localestr('Сума: ')}&nbsp;</b>{order.amount}<b>&nbsp;&nbsp;&nbsp;{localestr('винагорода: ')}&nbsp;</b>{order.reward}</div>}
          </div>))
        }</div>
      }
      showMsg(data, localestr('Замовлення в процесі ') + courier.name);
    }

    let notInDelivery = 0;
    let inDeliveryNotTaken = 0;
    let deliveredCount = 0;
    (CourierOrd || []).forEach(order => {
      const status = Number(order.status);
      const posted = Number(order.posted);
      if (status < 2 && !posted) notInDelivery++;
      else if (status >= 2 && !order.courier && !posted) inDeliveryNotTaken++;
      if (status >= 2 && order.courier && posted) deliveredCount++;
    });
    const couriersMap = {};
    (CourierOrd || []).forEach(order => {
      if (!order.courier) return;
      if (!couriersMap[order.courier]) {
        couriersMap[order.courier] = {
          id: order.courier,
          name: order.courier_name,
          cashAcc: order.cashAcc,
          taken: [],
          delivered: [],
          deliveredReward: 0,
          deliveredTotal0: 0,
          deliveredTotal1: 0,
          transactionsTotal: 0,
        };
      }
      const status = Number(order.status);
      const posted = Number(order.posted);
      if (status >= 2 && posted === 0) {
        couriersMap[order.courier].taken.push(order);
      } else if (status >= 2 && posted === 1) {
        couriersMap[order.courier].delivered.push(order);
        couriersMap[order.courier].deliveredReward += parseFloat(order?.reward || 0)
        if (order.payType === '0' && order.status !== '3') couriersMap[order.courier].deliveredTotal0 += parseFloat(order?.amount || 0)
        if (order.payType === '1' && order.status !== '3') couriersMap[order.courier].deliveredTotal1 += parseFloat(order?.amount || 0)
      }
    });

    const couriersArray = Object.values(couriersMap);

    (CourierTrn || []).forEach(order => {
      const i = couriersArray.findIndex(el => el.cashAcc === order.account)
      couriersArray[i].transactionsTotal += parseFloat(order.amount || 0)
    })

    return (
      <div style={{ display: "flex", flexDirection: window.innerWidth < 600 && open ? "column" : "row", width: "100%", height: "100%" }}>
        <div style={{ position: "relative", width: "100%", height: "100%", display: "flex", flexDirection: "row", flexWrap: "wrap", placeContent: "start", overflow: "auto" }}>
          <div style={stl1}><div className="button" style={stl2} onClick={() => { cmdClick(); }}>{localestr("Нове замовлення")}</div></div>
          {content}
        </div>
        <div className={open ? 'menu' : 'menu-hidden'}>
          <div className="wraper">
            {window.innerWidth < 600
              ? <div onClick={() => setOpen(!open)}>{open ? <>&#9662;</> : <>&#9652;</>}</div>
              : <div onClick={() => setOpen(!open)}>{open ? <>&#9656;</> : <>&#9666;</>}</div>
            }
          </div>
          <aside>
            <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div style={{ margin: '5px 10px 0' }}>
                <div style={window.innerWidth < 600 ? { marginTop: '10px', display: 'flex', justifyContent: 'space-between' } : {}}>
                  <div>
                    <div><b>{localestr("Не передані в доставку:")}</b> {notInDelivery}</div>
                    <div><b>{localestr("Не отримані кур'єрами:")}</b> {inDeliveryNotTaken}</div>
                    <div><b>{localestr("Загальна кількість виконаних:")}</b> {deliveredCount}</div>
                  </div>
                  {window.innerWidth < 600 && <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <div style={{ lineHeight: '40px', height: '40px', width: "40px", marginLeft: '5px' }} className="ord_button2 toolBarItem toolBarItem2" title={localestr("Звіт по кур'єрах")} onClick={() => { runCmd('prnRep3') }}>
                      <img style={{ width: '32px', height: '32px', color: 'white' }} src={icon + '#chart'} alt='' />
                    </div>
                    <div style={{ lineHeight: '40px', height: '40px', width: "40px" }} className="ord_button2 toolBarItem toolBarItem2" title={localestr("Кур'єри на карті")} onClick={() => { showMap("users", localestr("Карта кур'єрів")); }}>
                      <img style={{ width: '32px', height: '32px' }} src={icon + '#map_u'} alt='' />
                    </div>
                    <div style={{ lineHeight: '40px', height: '40px', width: "40px", marginLeft: '5px' }} className="ord_button2 toolBarItem toolBarItem2" title={localestr("Замовлення на карті")} onClick={() => { showMap("orders", localestr("Карта замовлень"), Orders); }}>
                      <img style={{ width: '32px', height: '32px' }} src={icon + '#map_o'} alt='' />
                    </div>
                  </div>}
                </div>
                <div style={{ marginTop: '10px', paddingTop: '5px', borderTop: '1px dashed #0008' }}>
                  <div><b>{localestr("Кур'єри:")}</b></div>
                  {couriersArray.map((cr) => (<div key={cr.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 5px 5px', marginTop: '5px', border: '1px dotted #0003' }}>
                    <div>
                      <div>{cr.name}</div>
                      <div>
                        <span onClick={() => { showDelivered(cr) }} style={{ color: 'blue', textDecoration: 'underline blue', cursor: 'pointer' }}>{localestr("Виконано:")}</span>&nbsp;{cr.delivered.length}
                        <span onClick={() => { showTaken(cr) }} style={{ color: 'blue', textDecoration: 'underline blue', cursor: 'pointer', marginLeft: '10px' }}>{localestr("В процесі:")}</span>&nbsp;{cr.taken.length}
                      </div>
                    </div>
                    <div>
                      <div style={{ height: '32px', width: "32px", marginTop: '5px' }} className="ord_button2 toolBarItem toolBarItem2" title={localestr("Місцезнаходження кур'єра на карті")} onClick={() => { showMap("users", localestr("Кур'єр ") + cr.name, [{ id: cr.id, name: cr.name }]); }}>
                        <img style={{ width: '25px', height: '25px' }} src={icon + '#map'} alt='' />
                      </div>
                    </div>
                  </div>))}
                </div>
              </div>
              {window.innerWidth >= 600 && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px 0' }}>
                <div style={{ width: "170px" }} className="ord_button2 toolBarItem toolBarItem2" title={localestr("Звіт по кур'єрах")} onClick={() => { runCmd('prnRep3') }}>
                  {localestr("Звіт по кур'єрах")}
                </div>
                <div style={{ width: "170px", marginTop: '5px' }} className="ord_button2 toolBarItem toolBarItem2" title={localestr("Замовлення на карті")} onClick={() => { showMap("orders", localestr("Карта замовлень"), Orders); }}>
                  {localestr("Замовлення на карті")}
                </div>
                <div style={{ width: "170px", marginTop: '5px' }} className="ord_button2 toolBarItem toolBarItem2" title={localestr("Кур'єри на карті")} onClick={() => { showMap("users", localestr("Карта кур'єрів")); }}>
                  {localestr("Кур'єри на карті")}
                </div>
              </div>}
            </div>
          </aside>
        </div>
      </div>
    );
  }
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', placeContent: 'start', overflow: 'auto' }}>
      <div style={stl1}><div className='button' style={stl2} onClick={() => { cmdClick() }}>{localestr('Нове замовлення')}</div></div>
      {content}
    </div>
  )
}

export default DeliveryTab